import { ref, computed, onMounted, onUnmounted } from "vue";
import { useState } from "#app";

export function useDevice() {
  const windowWidth = useState("windowWidth", () => (process.client ? window.innerWidth : 1024));

  const isMobile = computed(() => windowWidth.value <= 768);
  const isTablet = computed(() => windowWidth.value > 768 && windowWidth.value <= 1024);
  const isDesktop = computed(() => windowWidth.value > 1024);

  const updateWindowWidth = () => {
    if (import.meta.client) {
      windowWidth.value = window.innerWidth;
    }
  };

  onMounted(() => {
    updateWindowWidth();
    window.addEventListener("resize", updateWindowWidth);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", updateWindowWidth);
  });

  return { isMobile, isTablet, isDesktop };
}
